import { useEffect } from "react";
import axios from "axios";
import { nuclearn_api_url } from "src/App";
import type { SubAgentRun } from "src/views/assistant/types";

/**
 * Restore delegated sub-agent cards for a loaded dialogue so they survive
 * navigating away and back. Live cards (a still-running turn) are merged,
 * not clobbered — hydrateSubAgents dedupes by sub-agent dialogue id.
 */
export function useRestoreSubAgents(
  dialogueId: number | string | null | undefined,
  hydrateSubAgents: ((runs: SubAgentRun[]) => void) | undefined,
  enabled = true,
) {
  useEffect(() => {
    if (!dialogueId || !enabled || !hydrateSubAgents) return;
    let cancelled = false;
    axios
      .get(`${nuclearn_api_url}/agent/subagents/${dialogueId}`)
      .then((resp) => {
        if (cancelled) return;
        const runs = resp.data?.runs ?? [];
        if (runs.length > 0) hydrateSubAgents(runs);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [dialogueId, enabled, hydrateSubAgents]);
}
